import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Hard paywall when a free trial has ended (no +30 grace).
 * Managers are sent to /plans; non-managers use SubscriptionEnded.
 */
const TrialExpiredModal = ({ setShowPaymentModal, canManage }) => {
  return (
    <div className='modal' style={{ display: 'block', background: 'rgba(0,0,0,.8)', height: '100vh' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          maxHeight: '90vh',
          maxWidth: '800px',
          margin: '0 auto',
        }}>
        <div className='modal-content bg-card text-card-foreground'>
          <div className='modal-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h4 className='modal-title' style={{ textAlign: 'left' }}>
              Free trial ended
            </h4>
            {/* Keep dismiss for owners who need to reach /plans via the banner/sidebar later;
                product routes remain gated until they upgrade. */}
            <button type='button' className='modal-close' onClick={() => setShowPaymentModal(false)}>
              <X size={16} strokeWidth={1.5} />
            </button>
          </div>
          <div className='modal-body space-y-3'>
            <p>
              Your 14-day free trial has ended and access to the product is locked until you choose a plan.
              There is no grace period on trials.
            </p>
            {canManage ? (
              <p className='text-muted-foreground'>Select a plan to continue, or contact sales for Discover / Govern.</p>
            ) : (
              <p className='text-muted-foreground'>Ask your organisation owner to choose a plan to restore access.</p>
            )}
          </div>
          <div className='modal-footer flex gap-2'>
            {canManage && (
              <Button asChild>
                <Link to='/plans' onClick={() => setShowPaymentModal(false)}>
                  Choose a plan
                </Link>
              </Button>
            )}
            <Button variant='outline' onClick={() => setShowPaymentModal(false)}>
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialExpiredModal;
